import { useEffect, useRef, useState } from "react";

const feedbackMs = 1600;

// Copies text to the clipboard and flags "copied" for a moment, so the
// button can read "Copied" (checklists and the 30 day plan).
export function useCopyFeedback() {
  const initialState = { isCopied: false };
  const [state, setState] = useState(initialState);
  const timerRef = useRef<number | undefined>(undefined);

  useEffect(() => {
    function clearTimer() {
      window.clearTimeout(timerRef.current);
    }
    return clearTimer;
  }, []);

  const showCopied = () => {
    setState((state) => ({ ...state, isCopied: true }));
    window.clearTimeout(timerRef.current);
    timerRef.current = window.setTimeout(
      () => setState((state) => ({ ...state, isCopied: false })),
      feedbackMs,
    );
  };

  const copy = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
    } catch {
      // Clipboard blocked: still acknowledge the press, like the preview.
    }
    showCopied();
  };

  return { isCopied: state.isCopied, copy };
}
